import { api } from '../clients';
import { ProcessTaskResponse, Tasks } from './types';

export const dispatchTask = (taskType: Tasks, payload: Record<string, unknown>) =>
	api.post<{ task_id: string }, { task_id: string }>(`tasks/`, { task_type: taskType, ...payload });

export const getTask = (taskId: string) => api.get<ProcessTaskResponse, ProcessTaskResponse>(`tasks/${taskId}/`);
